import * as React from 'react';
import { WhiteLabelMobileButton, WhiteLabelMobileCarrierSection } from '@mitchell/react.component.ux';
import { TranslationService, EMPTY_TEXT } from "../../common";
import { PhotoCaptureConstants, PhotoCaptureGPCMessageConstants, PhotoCaptureMessageConstants } from '../constants';
import { PhotoCaptureAssignmentTypes, PhotoCaptureMessageType } from '../enums';
import { replaceMesssageTagToValue, getEstimatorSummaryHeaderText, getHtmlUrlString } from '../utilities';
import { Content, StyledDivThankYou, StyledDivRedirection } from './ScriptQuestionComponent.style';
export const PhotoCaptureMessage = ({ appTheme, messageType, underWritingCompanyName, claimNumber, assignmentType, autoRedirectionUrl = '', isLoading, redirectionMethod, isShopUpdatedByUser, isRepairShopEnable, isShopSelectionScreenVisited, hasEstimatorWorkflow, userVehicleInfo, vehicle }) => {
    const translate = TranslationService.translate;
    const variableOptions = {
        '[Underwriting Company Name]': underWritingCompanyName,
        '[Custom Note]': '',
        '[First Name]': '',
        '[Last Name]': '',
        '[Claim Number]': claimNumber
    };
    const [message, setMessage] = React.useState(EMPTY_TEXT);
    let estimatorSummaryHeaderText = EMPTY_TEXT;
    React.useEffect(() => {
        if (!isLoading) {
            setMessage(replaceMesssageTagToValue(getErrorMessageByAssignmentType(messageType, appTheme.uploadSuccessfulMessage), variableOptions));
        }
    }, [isLoading]);
    if (hasEstimatorWorkflow)
        estimatorSummaryHeaderText = getEstimatorSummaryHeaderText(userVehicleInfo !== null && userVehicleInfo !== void 0 ? userVehicleInfo : vehicle);
    const getErrorMessageByAssignmentType = (messageType, message) => {
        const messageConstant = assignmentType === PhotoCaptureAssignmentTypes.GENRIC_PHOTO_CAPTURE
            ? PhotoCaptureGPCMessageConstants
            : PhotoCaptureMessageConstants;
        if (messageType === PhotoCaptureMessageType.SUCCESS) {
            if (isRepairShopEnable && isShopSelectionScreenVisited) {
                if (isShopUpdatedByUser) {
                    return appTheme.selectShopBookedMessage || translate(PhotoCaptureConstants.SELECT_SHOP_MESSAGE);
                }
                else {
                    return appTheme.shopNotBookedMessage || translate(PhotoCaptureConstants.SHOP_NOT_SELECT_MESSAGE);
                }
            }
            return message;
        }
        else if (hasEstimatorWorkflow && messageType === PhotoCaptureMessageType.CLOSED) {
            return translate(PhotoCaptureMessageConstants[`${messageType}_ESTIMATOR_MESSAGE`]);
        }
        else if (messageType === PhotoCaptureMessageType.CLOSED) {
            return appTheme.postUploadRevisitMessage
                ? appTheme.postUploadRevisitMessage
                : assignmentType === PhotoCaptureAssignmentTypes.GENRIC_PHOTO_CAPTURE
                    ? translate(PhotoCaptureGPCMessageConstants[`${messageType}_MESSAGE`])
                    : translate(PhotoCaptureMessageConstants[`${messageType}_MESSAGE`]);
        }
        else {
            const estimatorKey = `${messageType}_ESTIMATOR_MESSAGE`;
            const messageKey = hasEstimatorWorkflow && messageConstant[estimatorKey] ? estimatorKey : `${messageType}_MESSAGE`;
            return translate(messageConstant[messageKey]);
        }
    };
    React.useEffect(() => {
        if (redirectionMethod === PhotoCaptureMessageConstants.AUTO &&
            autoRedirectionUrl &&
            messageType === PhotoCaptureMessageType.SUCCESS) {
            setTimeout(() => {
                window.location.href = getHtmlUrlString(autoRedirectionUrl);
            }, 2000);
        }
    }, [autoRedirectionUrl]);
    const redirectToAutoRedirectionUrl = () => (window.location.href = getHtmlUrlString(autoRedirectionUrl));
    const quillEditorText = messageType === PhotoCaptureMessageType.CLOSED || messageType === PhotoCaptureMessageType.SUCCESS
        ? `<div class="ql-editor">${message}</div>`
        : message;
    return (React.createElement(Content, null,
        React.createElement(WhiteLabelMobileCarrierSection, { headerText: estimatorSummaryHeaderText || appTheme.headerText, headerBackgroundColor: appTheme.headerBackgroundColor, headerColor: appTheme.headerColor, speechBoxRichText: quillEditorText, speechBoxBackgroundColor: appTheme.speechBoxBackgroundColor, avatarUrl: appTheme.avatarUrl, avatarColor: appTheme.avatarColor, languageOptions: [], languageFontSize: appTheme.languageFontSize, languageFontColor: appTheme.languageFontColor, languageGlobeColor: appTheme.languageGlobeColor, islanguageHide: true }),
        messageType === PhotoCaptureMessageType.SUCCESS && (React.createElement(StyledDivThankYou, { className: "mi-icon-good-job-filled-circle", thumbsUpColor: appTheme.thumbsUpColor })),
        autoRedirectionUrl &&
            messageType === PhotoCaptureMessageType.SUCCESS &&
            redirectionMethod === PhotoCaptureMessageConstants.USER && (React.createElement(StyledDivRedirection, { container: true, item: true, direction: "row", alignItems: "flex-start", justify: "center", wrap: "nowrap" },
            React.createElement(WhiteLabelMobileButton, { id: "btnRedirect", label: translate(appTheme.redirectionButtonText || PhotoCaptureMessageConstants.REDIRECT), buttonBackgroundColor: appTheme.buttonBackgroundColor, buttonTextColor: appTheme.buttonTextColor, onClick: redirectToAutoRedirectionUrl })))));
};
//# sourceMappingURL=PhotoCaptureMessage.js.map